import React, { Component } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  Button,
  CardHeader,
  CardBody
} from "reactstrap";

import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { ViewDefaultTextInput } from "../../Shared/Forms/ViewDefaultTextInput";

import { PhoneInput } from "../../Shared/Forms/PhoneInput";
import "../../Shared/Forms/form.css";

class ViewInstructorDetails extends Component {
  state = {
    canSubmit: false,
    countryCode: null,
    showInterests: false
  };

  handleSubmit = data => {
    var countryCodes = `+${this.state.countryCode}${data.mobileNumber}`;
    return countryCodes;
  };

  resetForm = () => {
    this.refs.viewinstructorDetails.reset();
  };
  ClearAll = () => {
    this.props.reset();

    this.resetForm();
  };

  getCountryCode = code => {
    this.setState({
      countryCode: code
    });
  };

  render() {
    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      InstructorInterests,
      showInterests
    } = this.props;

    return (
      <Row>
        <Col>
          <Card>
            <CardHeader>Instructor Profile </CardHeader>
            <CardBody>
              {error ? <Alert color="danger">{error.message}</Alert> : null}
              <Formsy
                ref="viewinstructorDetails"
                onValidSubmit={this.handleSubmit}
              >
                <ViewDefaultTextInput
                  name="firstName"
                  value={
                    selectedRow && hasParams ? selectedRow.firstName : null
                  }
                  title="First Name"
                />
                <ViewDefaultTextInput
                  name="lastName"
                  value={selectedRow && hasParams ? selectedRow.lastName : null}
                  title="Last Name"
                />
                <ViewDefaultTextInput
                  name="emailAddress"
                  value={
                    selectedRow && hasParams ? selectedRow.emailAddress : null
                  }
                  title="Email"
                />
                <PhoneInput
                  name="mobileNumber"
                  value={
                    selectedRow && hasParams
                      ? `+${selectedRow.mobileNumber}`
                      : "+234"
                  }
                  title="Mobile Number"
                  getCountryCode={this.getCountryCode}
                  showInterests={showInterests}
                />
                <ViewDefaultTextInput
                  name="businessName"
                  value={
                    selectedRow && hasParams ? selectedRow.businessName : null
                  }
                  title="Business Name"
                />{" "}
                <Card className="mb-2">
                  <CardHeader>Interests</CardHeader>
                  <CardBody className="px-2 py-1">
                    {showInterests &&
                    InstructorInterests &&
                    InstructorInterests.length >= 1 ? (
                      InstructorInterests.map(interests => {
                        return (
                          <div className="tag mr-2 mb-1" key={interests.id}>
                            {interests.name}
                          </div>
                        );
                      })
                    ) : (
                      <div>Instructor not assigned any interest</div>
                    )}
                  </CardBody>
                </Card>
                <Button
                  type="button"
                  color="primary"
                  outline
                  onClick={() => this.ClearAll()}
                >
                  {submitting ? <Spinner size="sm" /> : <div>Reset</div>}
                </Button>
              </Formsy>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default ViewInstructorDetails;
